export function currentEnv() {
  if (import.meta.env.VITE_APP_ENV === "local") {
    return "local";
  }
  if (import.meta.env.VITE_APP_ENV === "dev") {
    return "dev";
  }
  if (import.meta.env.VITE_APP_ENV === "qa") {
    return "qa";
  }
  if (import.meta.env.VITE_APP_ENV === "prod" || import.meta.env.VITE_APP_ENV === "demo") {
    return "production";
  }

  return "unknown";
}

export function reduxDevTools() {
  return import.meta.env.VITE_APP_ENV === "dev" || import.meta.env.VITE_APP_ENV === "qa";
}

export function reduxLogger() {
  return false;
}

export function reduxPersist() {
  return (
    // import.meta.env.VITE_APP_ENV === "dev" ||
    import.meta.env.VITE_APP_ENV === "qa" ||
    import.meta.env.VITE_APP_ENV === "demo" ||
    import.meta.env.VITE_APP_ENV === "prod"
  );
}
